import { FeedbackManager } from '@mojility/coach-core';

export class ActionButton {

  constructor($element) {
    this.container = $element[ 0 ];
    this.labels = {
      ready: '',
      busy: 'Processing',
      fail: 'Failed'
    };
    this.canExecute = true;
  }

  get feedbackManager() {
    if (this._feedbackManager === undefined) this._feedbackManager = new FeedbackManager(this.container, this.labels);
    return this._feedbackManager;
  }

  get initialText() {
    return this.labels.ready;
  }

  set initialText(value) {
    if (value)
      this.labels.ready = value;
  }

  set busyText(value) {
    if (value)
      this.labels.busy = value;
  }

  execute() {
    if (this.canExecute) {
      this.chainFeedbackToPromise(this.action());
      this.canExecute = false;
    }
  }

  chainFeedbackToPromise(promise) {
    promise
      .then(() => this.feedbackManager.finish(), () => this.feedbackManager.fail())
      .then(() => this.canExecute = true);
    this.feedbackManager.start();
  }

  get isIconPresent() {
    return this.icon ? true : false;
  }

  get iconPath() {
    return `/images/icons/${this.icon}.svg`;
  }
}
